export default __webpack_public_path__ + "static/certificate-iso-0db17911a949ca25345f3aab8f27a5cb.svg";